import React from 'react';
import PropTypes from 'prop-types';

import {Checkbox, Stack, Typography, Tooltip, IconButton} from 'views/components';
import {InfoOutlined} from 'views/icons';
import {Translate, translate} from 'views/module';

const PrivacyCheckbox = (props) => {
  const {
    isFeedbackPrivacyRequired,
    setIsFeedbackPrivacyRequired,
  } = props;

  return (
    <Stack sx={{width: '100%'}}>
      <Checkbox
        onChange={(newValue) => setIsFeedbackPrivacyRequired(newValue)}
        checked={isFeedbackPrivacyRequired}
        sx={{
          'border': '#e3e3e6',
          '&.Mui-checked': {
            color: '#10a4a0',
          },
          '&:hover': {
            color: '#10a4a0',
          },
        }}
        label={
          <Stack direction="row" alignItems="center">
            <Typography color='color.black'>
              <Translate expression='eventFeedback.PrivacyRequiredLabel' />
            </Typography>
            <Tooltip
              title={translate('eventFeedback.PrivacyRequiredHoverDialogue')}
              placement="top"
              slotProps={{
                tooltip: {
                  sx: {
                    bgcolor: 'color.black',
                    color: 'color.white',
                  },
                },
              }}
            >
              <IconButton
                color="primary"
                onClick={() => {}}
                sx={{
                  'color': 'grey.600',
                  '&:hover': {
                    color: 'grey.800',
                  },
                }}
              >
                <InfoOutlined />
              </IconButton>
            </Tooltip>
          </Stack>
        }
      />
    </Stack>
  );
};

PrivacyCheckbox.propTypes = {
  isFeedbackPrivacyRequired: PropTypes.bool.isRequired,
  setIsFeedbackPrivacyRequired: PropTypes.func.isRequired,
};

export default React.memo(PrivacyCheckbox);
